import { MutableRefObject, useEffect, useState } from 'react';

/**
 * Checks is element is pinned to the top
 * https://css-tricks.com/how-to-detect-when-a-sticky-element-gets-pinned/
 */
export const useIsElementPinned = (ref: MutableRefObject<HTMLElement | null>) => {
  const [pinned, setPinned] = useState<boolean>(false);

  useEffect(() => {
    if (ref.current === null) return;
    const observer = new IntersectionObserver(([element]) => setPinned(element.intersectionRatio < 1), { threshold: [1] });

    observer.observe(ref.current);

    return () => observer.disconnect();
  }, [ref]);

  return pinned;
};
